/**
 * THIS FILE AUTOMATICALLY GENERATED, DO NOT EDIT!
 */
/**
 * Maps the post type to the respective sub-path
 * @type {[{path: string, postType: string},{path: string, postType: string},{path: string, postType: string},{path: string, postType: string}]}
 */

//  Needed for sitemap and things like that, first locale is condisdered to be default locale
export const configuredLanguages = ["en", "de"];

// TODO on setup: post type path mapping extend with custom post types if necessary
// Language is only used to know which language it is, but never used!
// Path name is displayed in breadcrumbs
export const customPostTypesPathMapping = [
  { postType: "audios", path: "audio", language: "en" },
  { postType: "blog", path: "aktuelles", language: "en" },
  { postType: "catalog", path: "katalog", language: "en" },
  { postType: "events", path: "termine", language: "en" },
  { postType: "videos", path: "video", language: "en" },
  { postType: "audios", path: "audio", language: "de" },
  { postType: "blog", path: "aktuelles", language: "de" },
  { postType: "catalog", path: "katalog", language: "de" },
  { postType: "events", path: "termine", language: "de" },
  { postType: "videos", path: "video", language: "de" },
];

export function getPostTypeForPath(path: string) {
  return customPostTypesPathMapping.filter((mapping) => {
    return mapping.path === path;
  });
}

/** get list with all unigue post types for static path generation **/
export const postTypes = [
  ...new Set(
    customPostTypesPathMapping.map((item) => {
      return item.postType;
    }),
  ),
];
